<template>
  <b-container fluid class="competition-frame competition-steps">
    <b-row class="competition-top-row-position step2-name">
      <h2>{{ stepOneValues.name }}</h2>
    </b-row>
    <b-row class="competition-top-row-position step2-code">
      <p>{{ stepOneValues.code }}</p>
    </b-row>
    <b-row>
      <b-col md="1">
        <competition-step-progress />
      </b-col>
      <b-col md="11" class="pt-2">
        <b-row class="competition-col-pd">
          <h4 class="pb-4">Felhívás további adatai</h4>
        </b-row>
        <b-row class="competition-col-pd">
          <b-col md="6" class="padding0">
            <label class="competition-label float-left">Típus</label>
            <dropdown
              class="dropdown-competition"
              :label="typeLabel"
              :items="competitionTypesArray"
              @onChanged="typeChanged"
              :item="stepTwoValues.type"
            />
          </b-col>
          <b-col md="6" class="padding0">
            <label class="competition-label float-left">Altípus</label>
            <dropdown
              class="dropdown-competition"
              :label="subTypeLabel"
              :items="competitionSubTypesArray"
              @onChanged="subTypeChanged"
              :item="stepTwoValues.subType"
            />
            <input-error :v-if="stepTwoErrors.subType.length > 0" :errors="stepTwoErrors.subType" />
          </b-col>
        </b-row>
        <input-error :v-if="stepTwoErrors.type.length > 0" :errors="stepTwoErrors.type" />
        <b-row class="competition-col-pd mt-4">
          <b-form-group class="competition-textbox" label="Felhívás rövid összefoglalója">
            <b-form-textarea
              id="competition-text"
              :value="stepTwoValues.text"
              class="border inputFieldAlign"
              placeholder="Felhívás rövid összefoglalója"
              @change="onChanged('text', $event)"
              type="text"
            >
            </b-form-textarea>
            <input-error :v-if="stepTwoErrors.text.length > 0" :errors="stepTwoErrors.text"
          /></b-form-group>
        </b-row>
        <b-row class="mt-2">
          <b-col md="6">
            <b-form-group id="competition-state-subsidy" label="Állami támogatás">
              <b-form-input
                id="competition-state-subsidy"
                :value="stepTwoValues.stateSubsidy"
                class="border inputFieldAlign"
                placeholder="Állami támogatás"
                @change="onChanged('stateSubsidy', $event)"
                type="text"
              >
              </b-form-input>
              <input-error :v-if="stepTwoErrors.stateSubsidy.length > 0" :errors="stepTwoErrors.stateSubsidy"
            /></b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2 text-left">
          <b-col md="6">
            <b-form-group label="Beadási időszak kezdete">
              <b-form-datepicker
                class="competition-datepicker-input"
                locale="hu"
                reset-button
                label-reset-button="Törlés"
                label-help=""
                @input="onChanged('qualificationStart', $event)"
                :value="stepTwoValues.qualificationStart"
                placeholder="Beadási időszak kezdete"
              ></b-form-datepicker>
              <input-error
                :v-if="stepTwoErrors.qualificationStart.length > 0"
                :errors="stepTwoErrors.qualificationStart"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Beadási időszak vége ">
              <b-form-datepicker
                class="competition-datepicker-input"
                locale="hu"
                reset-button
                label-reset-button="Törlés"
                label-help=""
                @input="onChanged('qualificationEnd', $event)"
                :value="stepTwoValues.qualificationEnd"
                placeholder="Beadási időszak vége"
              ></b-form-datepicker>
              <input-error :v-if="stepTwoErrors.qualificationEnd.length > 0" :errors="stepTwoErrors.qualificationEnd"
            /></b-form-group>
          </b-col>
        </b-row>
        <b-card v-if="isApplication">
          <b-row>
            <b-col md="12" class="d-flex pl-3">
              Pályázat specifikus adatok
            </b-col>
            <b-col md="12" class="d-flex mt-2">
              <b-form-checkbox
                class="competition-checkbox"
                id="prequalification"
                :checked="stepTwoValues.preQualification"
                @change="onChanged('preQualification', $event)"
              >
                Előminősítés van
              </b-form-checkbox>
            </b-col>
            <b-col md="6" class="mt-4">
              <b-form-group label="Támogatás mértéke">
                <b-form-input
                  id="competition-subsidy"
                  :value="stepTwoValues.subsidy"
                  class="border inputFieldAlign"
                  placeholder="1.000.000 Ft"
                  @change="onChanged('subsidy', $event)"
                  type="text"
                >
                </b-form-input>
                <input-error v-if="stepTwoErrors.subsidy.length > 0" :errors="stepTwoErrors.subsidy"
              /></b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="stepTwoValues.preQualification" class="mt-2 text-left">
            <b-col md="6">
              <b-form-group label="Előminősítési időszak kezdete">
                <b-form-datepicker
                  class="competition-datepicker-input"
                  locale="hu"
                  reset-button
                  label-reset-button="Törlés"
                  label-help=""
                  @input="onChanged('preQualificationStart', $event)"
                  :value="stepTwoValues.preQualificationStart"
                  placeholder="Előminősítési időszak kezdete"
                ></b-form-datepicker>
                <input-error
                  :v-if="stepTwoErrors.preQualificationStart.length > 0"
                  :errors="stepTwoErrors.preQualificationStart"
              /></b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Előminősítési időszak vége">
                <b-form-datepicker
                  class="competition-datepicker-input"
                  locale="hu"
                  reset-button
                  label-reset-button="Törlés"
                  label-help=""
                  @input="onChanged('preQualificationEnd', $event)"
                  :value="stepTwoValues.preQualificationEnd"
                  placeholder="Előminősítési időszak vége"
                ></b-form-datepicker>
                <input-error
                  :v-if="stepTwoErrors.preQualificationEnd.length > 0"
                  :errors="stepTwoErrors.preQualificationEnd"
              /></b-form-group> </b-col
            ><b-col md="6">
              <b-form-group label="Előminősítési link"
                ><b-form-input
                  id="competition-prequalification-link"
                  :value="stepTwoValues.preQualificationLink"
                  class="border inputFieldAlign"
                  placeholder="http://google.com"
                  @change="onChanged('preQualificationLink', $event)"
                  type="text"
                ></b-form-input>
                <input-error
                  :v-if="stepTwoErrors.preQualificationLink.length > 0"
                  :errors="stepTwoErrors.preQualificationLink"
              /></b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="isCredit">
          <b-col md="12" class="d-flex pl-1">
            Hitel specifikus adatok
          </b-col>
          <b-row class="mt-4">
            <b-col md="6">
              <b-form-group label="Futamidő">
                <b-form-input
                  id="competition-credit-length"
                  :value="stepTwoValues.creditLength"
                  class="border inputFieldAlign"
                  placeholder="5 hónap"
                  @change="onChanged('creditLength', $event)"
                  type="text"
                >
                </b-form-input>
                <input-error v-if="stepTwoErrors.creditLength.length > 0" :errors="stepTwoErrors.creditLength" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Hitelösszeg">
                <b-form-input
                  id="competition-credit-amount"
                  :value="stepTwoValues.creditAmount"
                  class="border inputFieldAlign"
                  placeholder="5 millió Ft."
                  @change="onChanged('creditAmount', $event)"
                  type="text"
                >
                </b-form-input>
                <input-error v-if="stepTwoErrors.creditAmount.length > 0" :errors="stepTwoErrors.creditAmount" />
              </b-form-group>
            </b-col>
            <b-col md="6" class="mt-2">
              <b-form-group label="Kamat">
                <b-form-input
                  id="competition-credit-interest"
                  :value="stepTwoValues.creditInterest"
                  class="border inputFieldAlign"
                  placeholder="15%"
                  @change="onChanged('creditInterest', $event)"
                  type="text"
                >
                </b-form-input>
                <input-error v-if="stepTwoErrors.creditInterest.length > 0" :errors="stepTwoErrors.creditInterest"
              /></b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="isGuarantee">
          <b-col md="12" class="d-flex pl-1">
            Garancia specifikus adatok
          </b-col>
          <b-row class="mt-4">
            <b-col md="6">
              <b-form-group label="Éves díj">
                <b-form-input
                  id="competition-guarantee-cost"
                  :value="stepTwoValues.guaranteeCost"
                  class="border inputFieldAlign"
                  placeholder="5 millió Ft."
                  @change="onChanged('guaranteeCost', $event)"
                  type="text"
                >
                </b-form-input>
                <input-error v-if="stepTwoErrors.guaranteeCost.length > 0" :errors="stepTwoErrors.guaranteeCost" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Kezességvállalás maximuma ">
                <b-form-input
                  id="competition-guarantee-max"
                  :value="stepTwoValues.guaranteeMax"
                  class="border inputFieldAlign"
                  placeholder="5 millió Ft."
                  @change="onChanged('guaranteeMax', $event)"
                  type="text"
                >
                </b-form-input>
                <input-error v-if="stepTwoErrors.guaranteeMax.length > 0" :errors="stepTwoErrors.guaranteeMax" />
              </b-form-group>
            </b-col>
            <b-col md="6" class="mt-2">
              <b-form-group label="Kezességvállalás futamideje">
                <b-form-input
                  id="competition-guarantee-length"
                  :value="stepTwoValues.guaranteeLength"
                  class="border inputFieldAlign"
                  placeholder="5 millió Ft."
                  @change="onChanged('guaranteeLength', $event)"
                  type="text"
                >
                </b-form-input>
                <input-error v-if="stepTwoErrors.guaranteeLength.length > 0" :errors="stepTwoErrors.guaranteeLength" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="isCapitalProduct">
          <b-col class="d-flex pl-1" md="12">
            Tőktermék specifikus adatok
          </b-col>
          <b-row class="mt-4">
            <b-col md="6">
              <b-form-group label="Éves díj">
                <b-form-input
                  id="competition-capital-annual-cost"
                  :value="stepTwoValues.capitalAnnualCost"
                  class="border inputFieldAlign"
                  placeholder="5 millió Ft."
                  @change="onChanged('capitalAnnualCost', $event)"
                  type="text"
                >
                </b-form-input>
                <input-error
                  v-if="stepTwoErrors.capitalAnnualCost.length > 0"
                  :errors="stepTwoErrors.capitalAnnualCost"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Finanszírozás összege ">
                <b-form-input
                  id="competition-capital-amount"
                  :value="stepTwoValues.capitalAmount"
                  class="border inputFieldAlign"
                  placeholder="5 millió Ft."
                  @change="onChanged('capitalAmount', $event)"
                  type="text"
                >
                </b-form-input>
                <input-error v-if="stepTwoErrors.capitalAmount.length > 0" :errors="stepTwoErrors.capitalAmount" />
              </b-form-group>
            </b-col>
            <b-col md="6" class="mt-2">
              <b-form-group label="Befektetés időtartama">
                <b-form-input
                  id="competition-capital-investment-length"
                  :value="stepTwoValues.capitalInvestmentLength"
                  class="border inputFieldAlign"
                  placeholder="5 hónap"
                  @change="onChanged('capitalInvestmentLength', $event)"
                  type="text"
                >
                </b-form-input>
                <input-error
                  v-if="stepTwoErrors.capitalInvestmentLength.length > 0"
                  :errors="stepTwoErrors.capitalInvestmentLength"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" class="mt-2">
              <b-form-group label="Tőkealap futamideje">
                <b-form-input
                  id="competition-capital-length"
                  :value="stepTwoValues.capitalLength"
                  class="border inputFieldAlign"
                  placeholder="5 hónap"
                  @change="onChanged('capitalLength', $event)"
                  type="text"
                >
                </b-form-input>
                <input-error v-if="stepTwoErrors.capitalLength.length > 0" :errors="stepTwoErrors.capitalLength" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-row class="competition-step-button-row mt-2">
          <b-button class="competition-step-button back" @click="goBack">Előző lépés</b-button>
          <b-button class="competition-step-button" @click="save">Tovább</b-button>
        </b-row>
      </b-col>
    </b-row>
    <go-back-popup :step="1" />
  </b-container>
</template>

<script>
import { competitionTypes, getReadableCompetitionType } from '../../../constants/competitionTypes'
import { competitionSubTypes, getReadableCompetitionSubType } from '../../../constants/competitionSubTypes'
import Dropdown from '../../../components/Dropdown.vue'
import InputError from '../../../components/InputError.vue'
import CompetitionStepProgress from './CompetitionStepProgress.vue'
import { mapGetters } from 'vuex'
import GoBackPopup from '../../../components/GoBackPopup.vue'
export default {
  name: 'CompetitionStepTwo',
  components: { InputError, Dropdown, CompetitionStepProgress, GoBackPopup },
  created: function() {
    this.$store.commit('resetState')
    this.$store.commit('setStep', 2)
    if (this.$route.query.competitionId) {
      const { competitionId } = this.$route.query
      this.$store.dispatch('getCompetition', { step: 2, competitionId })
    } else {
      this.$router.push('not-found-page')
    }
  },
  mounted() {
    this.$store.commit('clearIsModified')
  },
  computed: {
    typeLabel: function() {
      if (this.stepTwoValues.type) {
        return this.stepTwoValues.type.name
      } else {
        return '- Válasszon -'
      }
    },
    subTypeLabel: function() {
      if (this.stepTwoValues.subType) {
        return this.stepTwoValues.subType.name
      } else {
        return '- Válasszon -'
      }
    },
    isCapitalProduct: function() {
      if (this.stepTwoValues.type) {
        return this.stepTwoValues.type.value === competitionTypes.CAPITAL_PRODUCT
      }
      return false
    },
    isGuarantee: function() {
      if (this.stepTwoValues.type) {
        return this.stepTwoValues.type.value === competitionTypes.GUARANTEE
      }
      return false
    },
    isCredit: function() {
      if (this.stepTwoValues.type) {
        return this.stepTwoValues.type.value === competitionTypes.CREDIT
      }
      return false
    },
    isApplication: function() {
      if (this.stepTwoValues.type) {
        return this.stepTwoValues.type.value === competitionTypes.APPLICATION
      }
      return false
    },
    competitionTypesArray: function() {
      const keys = Object.keys(competitionTypes)
      const result = []
      keys.forEach(key => {
        result.push({ value: competitionTypes[key], name: getReadableCompetitionType(competitionTypes[key]) })
      })
      return result
    },
    competitionSubTypesArray: function() {
      const keys = Object.keys(competitionSubTypes)
      const result = []
      keys.forEach(key => {
        result.push({ value: competitionSubTypes[key], name: getReadableCompetitionSubType(competitionSubTypes[key]) })
      })
      return result
    },
    ...mapGetters(['id', 'isModified', 'stepOneValues', 'stepTwoValues', 'stepTwoErrors'])
  },
  data: function() {
    return { item: null }
  },
  methods: {
    goBack: function() {
      if (this.isModified) {
        this.$root.$emit('bv::show::modal', 'goback-popup')
      } else {
        const path = `/competitions/competition/1`
        this.$router.push({ path, query: { competitionId: this.$route.query.competitionId } })
      }
    },
    onChanged: function(key, value) {
      this.$store.commit('setIsModified')
      this.$store.commit('setValue', { step: 'stepTwo', key, value })
    },
    save: function() {
      this.$store.dispatch('saveCompetition', { step: 2 })
    },
    typeChanged: function(value) {
      this.$store.commit('setIsModified')
      this.$store.commit('setType', JSON.parse(JSON.stringify(value)))
    },
    subTypeChanged: function(value) {
      this.$store.commit('setIsModified')
      this.onChanged('subType', value)
    }
  }
}
</script>
<style>
.competition-label {
  text-align: left;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  color: #636e72;
  padding-left: 10px;
}

.competition-textbox {
  width: 100%;
}

#competition-text {
  min-height: 200px;
}

.dropdown-competition {
  width: 100%;
}
.dropdown-competition > .dropdown-toggle {
  text-align: left;
  color: #5b6d75;
}
.dropdown-competition > .dropdown-toggle::after {
  float: right;
  margin-top: 10px;
}
.dropdown-competition > .btn-secondary {
  height: 48px;
  min-width: 110px;
  background: transparent;
  border: 1px solid #dfe6e9;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
.dropdown-competition > .btn-secondary:not(:disabled):not(.disabled):active,
.show > .btn-secondary.dropdown-toggle {
  /* color: #fff; */
  background-color: rgba(0, 143, 60, 0.6);
  border-color: #ae555b;
}
.padding0 {
  padding-left: 0;
  padding-right: 0;
}

.step2-name {
  font-weight: 700;
}
.step2-code {
  padding-top: 6px;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}
</style>
